var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.6474 5.64725L5.53688 0.503859L6.03756 -1.77899e-06L12 5.99977L6.03756 12L5.53688 11.4703L10.6451 6.35303L-1.39933e-05 6.35303L-1.39544e-05 5.64725L10.6474 5.64725Z",
  fill: "#4585FF"
})));
export default SvgIconArrow;